import React, { Suspense } from 'react';
import Loginv2 from '../viewsv2/UserManagement/Login';
import Signupv2 from '../viewsv2/UserManagement/Signup';
import NotFound from '../views/NotFound';
import RegisterConfirmationv2 from '../viewsv2/UserManagement/RegisterConfirmation';
import ResetPasswordv2 from '../viewsv2/UserManagement/ResetPassword';
import CreatePasswordv2 from '../viewsv2/UserManagement/CreatePassword';
import CreateAccountUsingEmail from '../viewsv2/UserManagement/CreateAccountUsingEmail';
import Activation from '../viewsv2/Activation';
import InvoiceFinancing from '../viewsv2/InvoiceFinancing';
import ApplicationV2 from '../viewsv2/Application';
import DashboardV2 from '../viewsv2/Dashboard';
import USLLCV2 from '../viewsv2/USLLC';
import EmailVerificationv2 from '../viewsv2/UserManagement/EmailVerification';
import CompanyUserDocuments from '../viewsv2/CompanyUserDocuments';
import MyAccount from '../viewsv2/UserManagement/MyAccount';
import InvitationSignup from '../viewsv2/UserManagement/InvitationSignup';
import MyAccountAdmin from '../viewsv2/UserManagement/MyAccountAdmin';
import ContactPage from '../viewsv2/UserManagement/ContactPage';
import TwoFactorAuthentication from '../viewsv2/UserManagement/TwoFactorAuthentication';
import BankingPage from '../viewsv2/Banking/Page';

import GlobalAccountsSkeleton from '../viewsv2/Banking/GlobalAccounts/skeleton';
import BankingPageAccountDetailSkeleton from '../viewsv2/Banking/PageAccountDetail/skeleton';
import BankingPageTransactionsSkeleton from '../viewsv2/Banking/PageTransactions/skeleton';
import BankingPageTransfersSkeleton from '../viewsv2/Banking/PageTransfers/skeleton';
import BankingPageRecipientsSkeleton from '../viewsv2/Banking/PageRecipients/skeleton';
import BankingPageConversionsSkeleton from '../viewsv2/Banking/PageConversions/skeleton';
import BankingPageRFIsSkeleton from '../viewsv2/Banking/PageRFIs/skeleton';
import BankingPageCardsSkeleton from '../viewsv2/Banking/Cards/skeleton';
import BankingReportingSkeleton from '../viewsv2/Banking/Reporting/skeleton';
import RevolvingCreditLineSkeleton from '../viewsv2/RevolvingCreditLine/skeleton';
import InvoicesListSkeleton from '../viewsv2/Invoicing/InvoicesList/skeleton';
import NewInvoiceSkeleton from '../viewsv2/Invoicing/NewInvoice/skeleton';
import ViewInvoiceSkeleton from '../viewsv2/Invoicing/ViewInvoice/skeleton';
import InvoicingSkeleton from '../viewsv2/Invoicing/skeleton';
import InvoicingClientsSkeleton from '../viewsv2/Invoicing/Clients/skeleton';
import InvoicingProductsSkeleton from '../viewsv2/Invoicing/Products/skeleton';

import BankingCardsGuard from '../components/BankingCardsGuard';
import InvoicingGuard from '../components/InvoicingGuard';
import InvoicingAccessGuard from '../components/InvoicingAccessGuard';
import FactoringCreditLineSkeleton from '../viewsv2/FactoringCreditLine/skeleton';
import ComplianceTermsGuard from '../componentsv2/ComplianceTermsGuard';
import CompliancePageSkeleton from '../viewsv2/CompanyUserCompliance/skeleton';

import {
  COMPANY_USER,
  DASHBOARD,
  NOT_FOUND,
  APPLICATION,
  LLC,
  VERIFY_EMAIL_SENT,
  LOGIN,
  RESET_PASSWORD,
  EMAIL_VERIFICATION,
  CREATE_NEW_PASSWORD,
  ACTIVATION,
  CREATE_ACCOUNT_USING_EMAIL,
  SIGNUP,
  INVOICE_FINANCING,
  MY_DOCUMENTS,
  MY_ACCOUNT,
  BUYER_SUMMARY,
  ADMIN_DASHBOARD,
  INVITATION_SIGNUP,
  INVOICES,
  MY_ACCOUNT_ADMIN,
  CONTACT,
  BANKING_CONNECTED_ACCOUNTS,
  BANKING_CONNECTED_ACCOUNT_DETAIL,
  BANKING_CASH_CONTROL_CONNECTED_ACCOUNTS,
  PAYMENTS,
  BANKING_REPORTS,
  REPORTING,
  AR_AGING,
  TRACKING,
  TRACK_INVOICE_ROUTE,
  POST_CC,
  POST_CC_DETAIL,
  BANKING,
  BANKING_ACCOUNT_DETAIL,
  BANKING_TRANSACTIONS,
  BANKING_RECENT_TRANSACTIONS,
  PAYMENT_DETAILS,
  LOGS,
  BANKING_RECIPIENTS,
  BANKING_ADD_RECIPIENTS,
  BANKING_EDIT_RECIPIENTS,
  BANKING_TRANSFERS,
  TRANSFERS,
  TRANSFER_DETAILS,
  FINANCE_REQUEST,
  FINANCE_REQUEST_DETAIL,
  COMPLETED_FINANCE_REQUEST_DETAIL,
  BULK_FINANCE_REQUEST,
  FEEDBACK,
  FEEDBACK_DETAIL,
  COMPLIANCE,
  ADMIN_COMPLIANCE,
  ADMIN_REGISTERED_AGENT,
  ADMIN_PARTNERS,
  REGISTERED_AGENT_CONFIRM,
  DOCUMENTS,
  BANKING_CREATE_TRANSFER,
  BANKING_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID,
  BANKING_CREATE_TRANSFER_NEW_RECIPIENT,
  BANKING_CREATE_BATCH_TRANSFER,
  BANKING_CREATE_WALLET_RECIPIENT,
  BANKING_CONVERSIONS,
  BANKING_NEW_CONVERSION,
  BANKING_CARDS,
  BANKING_NEW_COMPANY_CARD,
  BANKING_NEW_EMPLOYEE_CARD,
  BANKING_UPDATE_CARD,
  BANKING_CARDS_SETTINGS,
  BANKING_GLOBAL_ACCOUNTS,
  BANKING_CREATE_GLOBAL_ACCOUNT,
  BANKING_ADMIN_CARDS,
  BANKING_ADMIN_RFIS,
  BANKING_LOW_ACTIVITY_ACCOUNTS,
  TWO_FACTOR_AUTHENTICATION,
  BANKING_REPORTING,
  BANKING_RECURRING_PAYMENTS,
  BANKING_CREATE_RECURRING_PAYMENT,
  BANKING_EDIT_RECURRING_PAYMENT,
  BANKING_KYC_ONBOARDING,
  BANKING_RFI,
  BANKING_RFIS,
  REVOLVING_CREDIT_LINE,
  REVOLVING_CREDIT_LINE_PAYMENT,
  INVOICING,
  INVOICING_CLIENTS,
  INVOICING_PRODUCTS,
  FACTORING_CREDIT_LINE,
  FACTORING_CREDIT_LINE_INVOICES,
  FACTORING_CREDIT_LINE_SELL,
  BANKING_CASH_CONTROL_CONNECTED_ACCOUNT_DETAIL,
  CASH_CONTROL_LENDERS,
  LENDER_DASHBOARD,
  LENDER_CLIENTS,
  LENDER_CLIENT_DETAIL,
  LENDER_CREATE_TRANSFER,
  LENDER_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID,
  LENDER_CREATE_TRANSFER_NEW_RECIPIENT,
  LENDER_TRANSACTIONS,
  LENDER_PROFILE,
  REVOLVING_CREDIT_LINE_ADMIN,
  INVOICING_LIST_INVOICES,
  INVOICING_NEW_INVOICE,
  INVOICING_EDIT_INVOICE,
  INVOICING_VIEW_INVOICE,
  INVOICE_PUBLIC_VIEWER_ROUTE,
} from '../constants/auth';

const AirwallexKycEmbedded = React.lazy(() => import('../viewsv2/Banking/Application/AirwallexKycEmbedded'));
const AirwallexRfiEmbedded = React.lazy(() => import('../viewsv2/Banking/Application/AirwallexRfiEmbedded'));
const BankingPageRFIs = React.lazy(() => import('../viewsv2/Banking/PageRFIs'));
const BankingMetrics = React.lazy(() => import('../viewsv2/Banking/Metrics'));
const BankingPageAccountDetail = React.lazy(() => import('../viewsv2/Banking/PageAccountDetail'));
const BankingPageTransactions = React.lazy(() => import('../viewsv2/Banking/PageTransactions'));
const BankingRecentTransactions = React.lazy(() => import('../viewsv2/Banking/RecentTransactions'));
const AuditLogs = React.lazy(() => import('../viewsv2/AuditLogs'));
const Feedback = React.lazy(() => import('../viewsv2/Feedback'));
const FeedbackDetail = React.lazy(() => import('../viewsv2/FeedbackDetail'));
const BankingPageRecipients = React.lazy(() => import('../viewsv2/Banking/PageRecipients'));
const BankingPageAddRecipientsEmbedded = React.lazy(
  () => import('../viewsv2/Banking/PageAddRecipientsEmbedded')
);
const BankingEditRecipient = React.lazy(() => import('../viewsv2/Banking/EditRecipient'));
const BankingPageTransfers = React.lazy(() => import('../viewsv2/Banking/PageTransfers'));
const BankingCreateTransfer = React.lazy(() => import('../viewsv2/Banking/CreateTransfer'));
const BankingCreateTransferExistingRecipient = React.lazy(
  () => import('../viewsv2/Banking/CreateTransferExistingRecipient')
);
const BankingCreateTransferNewRecipient = React.lazy(
  () => import('../viewsv2/Banking/CreateTransferNewRecipient')
);
const BankingCreateBatchTransfer = React.lazy(() => import('../viewsv2/Banking/CreateBatchTransfer'));
const BankingCreateWalletRecipient = React.lazy(() => import('../viewsv2/Banking/CreateWalletRecipient'));
const BankingRecurringPayments = React.lazy(() => import('../viewsv2/Banking/RecurringPayments'));
const BankingCreateRecurringPayment = React.lazy(() => import('../viewsv2/Banking/CreateRecurringPayment'));
const BankingEditRecurringPayment = React.lazy(() => import('../viewsv2/Banking/EditRecurringPayment'));
const BankingCards = React.lazy(() => import('../viewsv2/Banking/Cards'));
const BankingNewCompanyCard = React.lazy(() => import('../viewsv2/Banking/NewCompanyCard'));
const BankingNewEmployeeCard = React.lazy(() => import('../viewsv2/Banking/NewEmployeeCard'));
const BankingCardsSettings = React.lazy(() => import('../viewsv2/Banking/CardsSettings'));
const BankingUpdateCard = React.lazy(() => import('../viewsv2/Banking/UpdateCard'));
const BankingReporting = React.lazy(() => import('../viewsv2/Banking/Reporting'));
const CompanyUser = React.lazy(() => import('../viewsv2/CompanyView'));
const BuyerSummary = React.lazy(() => import('../viewsv2/BuyerSummary'));
const Invoices = React.lazy(() => import('../viewsv2/Invoices'));
const Transfers = React.lazy(() => import('../viewsv2/Transfers'));
const Payments = React.lazy(() => import('../viewsv2/Payments'));
const PaymentDetails = React.lazy(() => import('../viewsv2/PaymentDetails'));
const Reporting = React.lazy(() => import('../viewsv2/Reporting'));
const ArAging = React.lazy(() => import('../viewsv2/Reporting/ArAging'));
const BankingConnectedAccounts = React.lazy(() => import('../viewsv2/Banking/ConnectedAccounts'));
const BankingConnectedAccountDetail = React.lazy(() => import('../viewsv2/Banking/ConnectedAccountDetail'));
const BankingCashControlConnectedAccounts = React.lazy(
  () => import('../viewsv2/Banking/CashControlConnectedAccounts')
);
const CashControlConnectedAccountDetail = React.lazy(
  () => import('../viewsv2/CashControlConnectedAccountDetail')
);
const CashControlLenders = React.lazy(() => import('../viewsv2/CashControlLenders'));
const Tracking = React.lazy(() => import('../viewsv2/Tracking'));
const TrackShipment = React.lazy(() => import('../viewsv2/TrackShipment'));
const PostCreditCommittee = React.lazy(() => import('../viewsv2/PostCreditCommittee'));
const PostCreditCommitteeFlowDetail = React.lazy(() => import('../viewsv2/PostCreditCommitteeFlowDetail'));
const TransferDetails = React.lazy(() => import('../viewsv2/TransferDetails'));
const FinanceRequest = React.lazy(() => import('../viewsv2/FinanceRequest'));
const FinanceRequestDetail = React.lazy(() => import('../viewsv2/FinanceRequestDetail'));
const CompletedFinanceRequestDetail = React.lazy(() => import('../viewsv2/CompletedFinanceRequest'));
const BulkFinanceRequest = React.lazy(() => import('../viewsv2/BulkFinanceRequest'));
const ComplianceList = React.lazy(() => import('../viewsv2/ComplianceList'));
const RegisteredAgentList = React.lazy(() => import('../viewsv2/RegisteredAgentList'));
const Partners = React.lazy(() => import('../viewsv2/Partners'));
const RegisteredAgentConfirm = React.lazy(() => import('../viewsv2/RegisteredAgentConfirm'));
const CompanyUserCompliance = React.lazy(() => import('../viewsv2/CompanyUserCompliance'));
const Documents = React.lazy(() => import('../viewsv2/CompanyUserCompliance/Documents'));
const BankingPageConversions = React.lazy(() => import('../viewsv2/Banking/PageConversions'));
const BankingPageNewConversion = React.lazy(() => import('../viewsv2/Banking/PageNewConversion'));
const GlobalAccounts = React.lazy(() => import('../viewsv2/Banking/GlobalAccounts'));
const NewGlobalAccount = React.lazy(() => import('../viewsv2/Banking/NewGlobalAccount'));
const BankingAllCards = React.lazy(() => import('../viewsv2/Banking/AllCards'));
const BankingAllRfis = React.lazy(() => import('../viewsv2/Banking/AllRfis'));
const BankingLowActivityAccounts = React.lazy(() => import('../viewsv2/Banking/LowActivityAccounts'));
const RevolvingCreditLine = React.lazy(() => import('../viewsv2/RevolvingCreditLine'));
const InvoicesList = React.lazy(() => import('../viewsv2/Invoicing/InvoicesList'));
const NewInvoice = React.lazy(() => import('../viewsv2/Invoicing/NewInvoice'));
const ViewInvoice = React.lazy(() => import('../viewsv2/Invoicing/ViewInvoice'));
const Invoicing = React.lazy(() => import('../viewsv2/Invoicing'));
const InvoicingClients = React.lazy(() => import('../viewsv2/Invoicing/Clients'));
const InvoicingProducts = React.lazy(() => import('../viewsv2/Invoicing/Products'));
const FactoringCreditLine = React.lazy(() => import('../viewsv2/FactoringCreditLine'));
const FactoringCreditLineInvoices = React.lazy(() => import('../viewsv2/FactoringCreditLine/InvoicesPage'));
const FactoringCreditLineSell = React.lazy(() => import('../viewsv2/FactoringCreditLine/SellInvoicesPage'));
const RevolvingCreditLineAdmin = React.lazy(() => import('../viewsv2/RevolvingCreditLine/Admin'));
const RevolvingCreditLinePayment = React.lazy(() => import('../viewsv2/RevolvingCreditLine/Payment'));
const InvoiceViewer = React.lazy(() => import('../viewsv2/Invoicing/InvoiceViewer'));
const LenderDashboard = React.lazy(() => import('../viewsv2/Lender/Dashboard'));
const LenderClients = React.lazy(() => import('../viewsv2/Lender/Clients'));
const LenderClientDetail = React.lazy(() => import('../viewsv2/Lender/ClientDetail'));
const LenderTransactions = React.lazy(() => import('../viewsv2/Lender/Transactions'));
const LenderProfile = React.lazy(() => import('../viewsv2/Lender/Profile'));
const LenderCreateTransfer = React.lazy(() => import('../viewsv2/Lender/CreateTransfer'));
const LenderCreateTransferExistingRecipient = React.lazy(
  () => import('../viewsv2/Lender/CreateTransferExistingRecipient')
);
const LenderCreateTransferNewRecipient = React.lazy(
  () => import('../viewsv2/Lender/CreateTransferNewRecipient')
);

export const publicRoutesV2 = [
  { path: VERIFY_EMAIL_SENT, component: <RegisterConfirmationv2 /> },
  { path: LOGIN, component: <Loginv2 /> },
  { path: RESET_PASSWORD, component: <ResetPasswordv2 /> },
  { path: EMAIL_VERIFICATION, component: <EmailVerificationv2 /> },
  { path: CREATE_NEW_PASSWORD, component: <CreatePasswordv2 /> },
  { path: SIGNUP, component: <Signupv2 /> },
  { path: NOT_FOUND, component: <NotFound /> },
  { path: CREATE_ACCOUNT_USING_EMAIL, component: <CreateAccountUsingEmail /> },
  { path: REGISTERED_AGENT_CONFIRM, component: <RegisteredAgentConfirm /> },
];

export const standaloneRoutesV2 = [
  { path: TRACK_INVOICE_ROUTE, component: <TrackShipment /> },
  { path: INVOICE_PUBLIC_VIEWER_ROUTE, component: <InvoiceViewer /> },
];

export const allAccessibleRoutesV2 = [{ path: INVITATION_SIGNUP, component: <InvitationSignup /> }];

export const companyUserRoutesV2 = [
  { path: ACTIVATION, component: <Activation /> },
  { path: TWO_FACTOR_AUTHENTICATION, component: <TwoFactorAuthentication /> },
  { path: INVOICE_FINANCING, component: <InvoiceFinancing /> },
  { path: APPLICATION, component: <ApplicationV2 /> },
  { path: DASHBOARD, component: <DashboardV2 /> },
  { path: LLC, component: <USLLCV2 /> },
  { path: MY_DOCUMENTS, component: <CompanyUserDocuments /> },
  { path: BUYER_SUMMARY, component: <BuyerSummary /> },
  { path: INVOICES, component: <Invoices /> },
  { path: MY_ACCOUNT, component: <MyAccount /> },
  { path: CONTACT, component: <ContactPage /> },
  { path: TRANSFERS, component: <Transfers /> },
  { path: PAYMENTS, component: <Payments /> },
  { path: PAYMENT_DETAILS, component: <PaymentDetails /> },
  { path: REPORTING, component: <Reporting /> },
  { path: AR_AGING, component: <ArAging /> },
  { path: BANKING, component: <BankingPage /> },
  {
    path: BANKING_ACCOUNT_DETAIL,
    component: (
      <Suspense fallback={<BankingPageAccountDetailSkeleton />}>
        <BankingPageAccountDetail />
      </Suspense>
    ),
  },
  {
    path: BANKING_TRANSACTIONS,
    component: (
      <Suspense fallback={<BankingPageTransactionsSkeleton />}>
        <BankingPageTransactions />
      </Suspense>
    ),
  },
  {
    path: BANKING_RECIPIENTS,
    component: (
      <Suspense fallback={<BankingPageRecipientsSkeleton />}>
        <BankingPageRecipients />
      </Suspense>
    ),
  },
  { path: BANKING_ADD_RECIPIENTS, component: <BankingPageAddRecipientsEmbedded /> },
  { path: BANKING_EDIT_RECIPIENTS, component: <BankingEditRecipient /> },
  {
    path: BANKING_TRANSFERS,
    component: (
      <Suspense fallback={<BankingPageTransfersSkeleton />}>
        <BankingPageTransfers />
      </Suspense>
    ),
  },
  { path: BANKING_CREATE_TRANSFER, component: <BankingCreateTransfer /> },
  { path: BANKING_CREATE_BATCH_TRANSFER, component: <BankingCreateBatchTransfer /> },
  { path: BANKING_CREATE_WALLET_RECIPIENT, component: <BankingCreateWalletRecipient /> },
  {
    path: BANKING_REPORTING,
    component: (
      <Suspense fallback={<BankingReportingSkeleton />}>
        <BankingReporting />
      </Suspense>
    ),
  },
  {
    path: BANKING_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID,
    component: <BankingCreateTransferExistingRecipient />,
  },
  { path: BANKING_CREATE_TRANSFER_NEW_RECIPIENT, component: <BankingCreateTransferNewRecipient /> },
  { path: BANKING_RECURRING_PAYMENTS, component: <BankingRecurringPayments /> },
  { path: BANKING_CREATE_RECURRING_PAYMENT, component: <BankingCreateRecurringPayment /> },
  { path: BANKING_EDIT_RECURRING_PAYMENT, component: <BankingEditRecurringPayment /> },
  { path: BANKING_KYC_ONBOARDING, component: <AirwallexKycEmbedded /> },
  { path: BANKING_RFI, component: <AirwallexRfiEmbedded /> },
  {
    path: BANKING_RFIS,
    component: (
      <Suspense fallback={<BankingPageRFIsSkeleton />}>
        <BankingPageRFIs />
      </Suspense>
    ),
  },
  {
    path: BANKING_CONVERSIONS,
    component: (
      <Suspense fallback={<BankingPageConversionsSkeleton />}>
        <BankingPageConversions />
      </Suspense>
    ),
  },
  { path: BANKING_NEW_CONVERSION, component: <BankingPageNewConversion /> },
  {
    path: BANKING_CARDS,
    component: (
      <Suspense fallback={<BankingPageCardsSkeleton />}>
        <BankingCards />
      </Suspense>
    ),
  },
  {
    path: BANKING_NEW_COMPANY_CARD,
    component: (
      <BankingCardsGuard>
        <BankingNewCompanyCard />
      </BankingCardsGuard>
    ),
  },
  {
    path: BANKING_NEW_EMPLOYEE_CARD,
    component: (
      <BankingCardsGuard>
        <BankingNewEmployeeCard />
      </BankingCardsGuard>
    ),
  },
  {
    path: BANKING_CARDS_SETTINGS,
    component: (
      <BankingCardsGuard>
        <BankingCardsSettings />
      </BankingCardsGuard>
    ),
  },
  {
    path: BANKING_UPDATE_CARD,
    component: (
      <BankingCardsGuard>
        <BankingUpdateCard />
      </BankingCardsGuard>
    ),
  },
  {
    path: BANKING_GLOBAL_ACCOUNTS,
    component: (
      <Suspense fallback={<GlobalAccountsSkeleton />}>
        <GlobalAccounts />
      </Suspense>
    ),
  },
  { path: BANKING_CREATE_GLOBAL_ACCOUNT, component: <NewGlobalAccount /> },
  {
    path: REVOLVING_CREDIT_LINE,
    component: (
      <Suspense fallback={<RevolvingCreditLineSkeleton />}>
        <RevolvingCreditLine />
      </Suspense>
    ),
  },
  { path: REVOLVING_CREDIT_LINE_PAYMENT, component: <RevolvingCreditLinePayment /> },
  {
    path: INVOICING,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<InvoicingSkeleton />}>
          <Invoicing />
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: INVOICING_CLIENTS,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<InvoicingClientsSkeleton />}>
          <InvoicingGuard>
            <InvoicingClients />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: INVOICING_PRODUCTS,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<InvoicingProductsSkeleton />}>
          <InvoicingGuard>
            <InvoicingProducts />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: INVOICING_LIST_INVOICES,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<InvoicesListSkeleton />}>
          <InvoicingGuard>
            <InvoicesList />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: INVOICING_NEW_INVOICE,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<NewInvoiceSkeleton />}>
          <InvoicingGuard>
            <NewInvoice />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: FACTORING_CREDIT_LINE,
    component: (
      <Suspense fallback={<FactoringCreditLineSkeleton />}>
        <FactoringCreditLine />
      </Suspense>
    ),
  },
  {
    path: FACTORING_CREDIT_LINE_INVOICES,
    component: (
      <Suspense fallback={<FactoringCreditLineSkeleton />}>
        <FactoringCreditLineInvoices />
      </Suspense>
    ),
  },
  {
    path: FACTORING_CREDIT_LINE_SELL,
    component: (
      <Suspense fallback={<FactoringCreditLineSkeleton />}>
        <FactoringCreditLineSell />
      </Suspense>
    ),
  },
  {
    path: INVOICING_EDIT_INVOICE,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<NewInvoiceSkeleton />}>
          <InvoicingGuard>
            <NewInvoice />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  {
    path: INVOICING_VIEW_INVOICE,
    component: (
      <InvoicingAccessGuard>
        <Suspense fallback={<ViewInvoiceSkeleton />}>
          <InvoicingGuard>
            <ViewInvoice />
          </InvoicingGuard>
        </Suspense>
      </InvoicingAccessGuard>
    ),
  },
  { path: TRANSFER_DETAILS, component: <TransferDetails /> },
  { path: FINANCE_REQUEST, component: <FinanceRequest /> },
  { path: FINANCE_REQUEST_DETAIL, component: <FinanceRequestDetail /> },
  { path: COMPLETED_FINANCE_REQUEST_DETAIL, component: <CompletedFinanceRequestDetail /> },
  { path: BULK_FINANCE_REQUEST, component: <BulkFinanceRequest /> },
  {
    path: COMPLIANCE,
    component: (
      <ComplianceTermsGuard fallback={<CompliancePageSkeleton />}>
        <CompanyUserCompliance />
      </ComplianceTermsGuard>
    ),
  },
  {
    path: DOCUMENTS,
    component: (
      <ComplianceTermsGuard fallback={<CompliancePageSkeleton />} requireReadyForCompliance>
        <Documents />
      </ComplianceTermsGuard>
    ),
  },
];

export const adminRoutesV2 = [
  { path: COMPANY_USER, component: <CompanyUser /> },
  { path: ADMIN_DASHBOARD, component: <DashboardV2 /> },
  { path: MY_ACCOUNT_ADMIN, component: <MyAccountAdmin /> },
  { path: BANKING_CONNECTED_ACCOUNTS, component: <BankingConnectedAccounts /> },
  { path: BANKING_CONNECTED_ACCOUNT_DETAIL, component: <BankingConnectedAccountDetail /> },
  { path: BANKING_CASH_CONTROL_CONNECTED_ACCOUNTS, component: <BankingCashControlConnectedAccounts /> },
  { path: BANKING_CASH_CONTROL_CONNECTED_ACCOUNT_DETAIL, component: <CashControlConnectedAccountDetail /> },
  { path: CASH_CONTROL_LENDERS, component: <CashControlLenders /> },
  { path: BANKING_REPORTS, component: <BankingMetrics /> },
  { path: BANKING_RECENT_TRANSACTIONS, component: <BankingRecentTransactions /> },
  { path: BANKING_ADMIN_CARDS, component: <BankingAllCards /> },
  { path: BANKING_ADMIN_RFIS, component: <BankingAllRfis /> },
  { path: BANKING_LOW_ACTIVITY_ACCOUNTS, component: <BankingLowActivityAccounts /> },
  { path: TRACKING, component: <Tracking /> },
  { path: ADMIN_COMPLIANCE, component: <ComplianceList /> },
  { path: ADMIN_REGISTERED_AGENT, component: <RegisteredAgentList /> },
  { path: ADMIN_PARTNERS, component: <Partners /> },
  { path: REVOLVING_CREDIT_LINE_ADMIN, component: <RevolvingCreditLineAdmin /> },
  { path: POST_CC, component: <PostCreditCommittee /> },
  { path: POST_CC_DETAIL, component: <PostCreditCommitteeFlowDetail /> },
  { path: LOGS, component: <AuditLogs /> },
  { path: FEEDBACK, component: <Feedback /> },
  { path: FEEDBACK_DETAIL, component: <FeedbackDetail /> },
];

export const lenderRoutesV2 = [
  { path: LENDER_DASHBOARD, component: <LenderDashboard /> },
  { path: LENDER_CLIENTS, component: <LenderClients /> },
  { path: LENDER_CLIENT_DETAIL, component: <LenderClientDetail /> },
  { path: LENDER_CREATE_TRANSFER, component: <LenderCreateTransfer /> },
  {
    path: LENDER_CREATE_TRANSFER_EXISTING_RECIPIENT_WITH_ID,
    component: <LenderCreateTransferExistingRecipient />,
  },
  { path: LENDER_CREATE_TRANSFER_NEW_RECIPIENT, component: <LenderCreateTransferNewRecipient /> },
  { path: LENDER_TRANSACTIONS, component: <LenderTransactions /> },
  { path: LENDER_PROFILE, component: <LenderProfile /> },
];
